import { render, staticRenderFns } from "./binnen-of-buiten-schilderwerk.vue?vue&type=template&id=02000586"
import script from "./binnen-of-buiten-schilderwerk.vue?vue&type=script&lang=js"
export * from "./binnen-of-buiten-schilderwerk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports